import { APIModel } from './api-model.model'

export class APIShortcode extends APIModel {
    shortcodeId: number;
    shortcode: string;
    shortcodeRelation: number;
    shortcodeType: string;
    providerId: number;
    shortcodeEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        shortcodeId: number;
        shortcode: string;
        shortcodeRelation: number;
        shortcodeType: string;
        providerId: number;
        shortcodeEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.shortcodeId = params.shortcodeId
        this.shortcode = params.shortcode
        this.shortcodeRelation = params.shortcodeRelation
        this.shortcodeType = params.shortcodeType
        this.providerId = params.providerId
        this.shortcodeEnabled = params.shortcodeEnabled ? 1 : 0
    }
}
